type NullableItem<T> = T | null;

function padListToFillColumns<T>(list: T[], numColumns: number): NullableItem<T>[] {
  const remainder = list.length % numColumns;
  if (remainder === 0) return list;

  const padding = numColumns - remainder;
  const paddedList = [...list, ...Array(padding).fill(null)];
  return paddedList;
}

export default padListToFillColumns;
